/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description toExternalBuildingUrl
 */

export const toExternalBuildingUrl = (buildingId: number) => `/external/b/${buildingId}` as const
